var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.context.classes.groupRepeatable },
    [
      _vm.context.removePosition === "after" ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _c(
        "FormulateSlot",
        {
          attrs: {
            name: "remove",
            context: _vm.context,
            index: _vm.index,
            "remove-item": _vm.removeItem
          }
        },
        [
          _c(
            _vm.context.slotComponents.remove,
            _vm._b(
              {
                tag: "component",
                attrs: {
                  context: _vm.context,
                  index: _vm.index,
                  "remove-item": _vm.removeItem
                }
              },
              "component",
              _vm.context.slotProps.remove,
              false
            )
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.context.removePosition === "before" ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }